/* eslint-disable import/prefer-default-export */

export const formatClassName = (name = '') => {
  return name?.split(' ').join('-').toLowerCase();
};

export const plainOptionsStatuses = ['Unreviewed', 'Under Review', 'Approved', 'Action Required', 'Approved with risk'];
export const plainOptionsTags = ['New', 'Change Detected'];
